import { FormattedChildTariffsData, LinkedTariffsType } from './types'

export function formatTariffDataToKeyValuePairs(data: FormattedChildTariffsData['data']) {
	return data.map(item => [item.id, item])
}

export function formatModalText(data: string[]) {
	return `You are updating ${data.length} tariff${data.length == 1 ? '' : 's'}. Do you wish to continue?`
}

export function filterTariffsNotExpired(data: FormattedChildTariffsData['data']) {
	return data.filter(tariff => tariff.expired == 'No')
}

export function getTariffIdsToUpdate(data: FormattedChildTariffsData['data']) {
	return data.map(tariff => tariff.id)
}

export function formattedChildTariffsData(childTariffData: LinkedTariffsType['childTariffs'] = []) {
	const headings = {
		tariff: 'Tariff',
		id: 'ID',
	}
	const data = childTariffData.map(({ id, name, url, expired }) => ({
		tariff: { data: name, link: url },
		id,
		expired: expired ? 'Yes' : 'No',
		checked: false,
	}))

	return { headings, data }
}
